import { mapStyles, markerIcon } from '../directory-map';

// Lightweight single-pin map for a directory entity single page. Mirrors the
// directory/modal map styling (brand mapStyles + typed marker) without the
// district boundary or route toggles the Visit map carries. Reads lat/lng/zoom/
// type/label from data-attributes and shares the global _loadGoogleMaps loader.
document.addEventListener('alpine:init', () => {
  Alpine.data('entityMap', () => ({
    async init() {
      const el = this.$refs.map ?? this.$el;
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      const zoom = parseInt(el.dataset.zoom, 10) || 15;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

      try {
        await window._loadGoogleMaps();
      } catch {
        return; // no API key / load failure — leave the container empty
      }

      const map = new google.maps.Map(el, {
        center: { lat, lng },
        zoom,
        styles: mapStyles(),
        disableDefaultUI: true,
        zoomControl: true,
        gestureHandling: 'cooperative',
      });

      new google.maps.Marker({
        position: { lat, lng },
        map,
        title: el.dataset.label || '',
        icon: markerIcon({ type: el.dataset.type }),
      });
    },
  }));
});
